import * as HYPERCUBEJS from '@hypercubejs/hypercubejs';

import {ScriptCoreMountain} from './coremountain.script.js';

import ambiant from './mountain.mp3';

// import ambiant from './Aperture-Tag-OST-28-Central-Hub-_152kbit_Opus_.mp3';
// import ambiant2 from './Fountain Water Bubbling.mp3';

function gameobjectcoremountain() {

    const coremountain = new HYPERCUBEJS.Node('coremountain');
    const meshcoremountain = new HYPERCUBEJS.MeshIcosahedron('meshcoremountain');
    const materialmeshcoremountain = new HYPERCUBEJS.MaterialColor('materialmeshcoremountain', {'color': [0.8, 0.2, 0.2]});

    meshcoremountain.setmaterial(materialmeshcoremountain);
    coremountain.addmesh(meshcoremountain);
    coremountain.setaudio(new Audio(ambiant));
    coremountain.setscript(new ScriptCoreMountain());

    coremountain.setcomponent('collideraabb', {

        'type': 'static',

        'min': [-1, -1, -1],
        'max': [1, 1, 1]
    });

    return coremountain;
}

export {

    gameobjectcoremountain
};

export default gameobjectcoremountain;
